/* eslint-enable @typescript-eslint/no-explicit-any */
export var requiredNullableString = function requiredNullableStringValidator(props, propName, componentName) {
    if (props[propName] === null || typeof props[propName] === 'string') {
        return null;
    }
    var err = componentName + ": prop \"" + propName + "\" must be null or string; received " + typeof props[propName];
    return new TypeError(err);
};
//# sourceMappingURL=customPropTypes.js.map